import * as actions from "Actions";
import * as api from "Api";

export const fetchBlogCategories = () => (dispatch, getState) => {
  const { auth, params } = getState();
  const { token } = auth;
  const { lng } = params;

  if (token === "") {
    return null;
  }
  return dispatch(
    actions.fetchBlogCategories(api.getBlogCategories({ token, lng }))
  );
};

export const fetchBlogTypes = () => (dispatch, getState) => {
  const { auth, params } = getState();
  const { token, navCommunity } = auth;

  if (token === "") {
    return null;
  }
  return dispatch(
    actions.fetchBlogTypes(
      api.getBlogTypes({
        token,
        communityId: navCommunity.id,
        lng: params.lng
      })
    )
  );
};

export const fetchBlogThemes = () => (dispatch, getState) => {
  const { auth, params } = getState();
  const { token, navCommunity } = auth;

  if (token === "") {
    return null;
  }
  return dispatch(
    actions.fetchBlogThemes(
      api.getBlogThemes({
        token,
        communityId: navCommunity.id,
        lng: params.lng
      })
    )
  );
};

export const fetchMediaCategories = ({ limit = 100 }) => (
  dispatch,
  getState
) => {
  const { token } = getState().auth;

  if (token === "") {
    return null;
  }
  return dispatch(
    actions.fetchMediaCategories(
      api.getMediaCategories({
        token,
        limit
      })
    )
  );
};

/*export const fetchMediaTypes = ({ limit }) => (dispatch, getState) => {
  const { auth } = getState();
  const { token /*, user*, navCommunity } = auth;

  if (token === "") {
    return null;
  }
  return dispatch(
    actions.fetchMediaTypes(
      api.getMediaTypes({
        token,
        communityId: navCommunity.id,
        limit
      })
    )
  );
};

export const fetchEventCategories = ({ limit }) => (dispatch, getState) => {
  const { auth } = getState();
  const { token , navCommunity } = auth;

  if (token === "") {
    return null;
  }
  return dispatch(
    actions.fetchEventCategories(
      api.getEventCategories({
        token,
        communityId: navCommunity.id,
        limit
      })
    )
  );
};

export const fetchEventTypes = ({ limit }) => (dispatch, getState) => {
  const { auth } = getState();
  const { token , navCommunity } = auth;

  if (token === "") {
    return null;
  }
  return dispatch(
    actions.fetchEventTypes(
      api.getEventTypes({
        token,
        communityId: navCommunity.id,
        limit
      })
    )
  );
};

export const fetchEmailingCategories = ({ limit }) => (dispatch, getState) => {
  const { auth } = getState();
  const { token , navCommunity } = auth;

  if (token === "") {
    return null;
  }
  return dispatch(
    actions.fetchEmailingCategories(
      api.getEmailingCategories({
        token,
        communityId: navCommunity.id,
        limit
      })
    )
  );
};

export const fetchEmailingTypes = ({ limit }) => (dispatch, getState) => {
  const { auth } = getState();
  const { token , navCommunity } = auth;

  if (token === "") {
    return null;
  }
  return dispatch(
    actions.fetchEmailingTypes(
      api.getEmailingTypes({
        token,
        communityId: navCommunity.id,
        limit
      })
    )
  );
};*/



// WEBPACK FOOTER //
// ./src/actions/thunks/filter.js